import React, { useEffect } from 'react';
import {
  Accordion,
  Container,
  AccordionSummary,
  AccordionDetails,
  Typography,
  AppBar,
  Toolbar
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import StockIssue from './StockIssue';
import StockReturnReport from './StockReturnReport';
import StockSummaryReport from './StockSummaryReport';
import VendorPurchaseReport from './VendorPurchaseReport';
import StockMovementReport from './StockMovementReport';
// import AdmReport from './AdmReport';

import { useParams } from "react-router-dom";
import base64 from "base64-js";

function InventoryReport() {
  const { encodedFormId } = useParams();

  const decodeFormId = (encodedFormId) => {
    const bytes = base64.toByteArray(encodedFormId);
    return new TextDecoder().decode(bytes);
  };

  const formId = decodeFormId(encodedFormId);

  useEffect(() => {
    console.log("Decoded formId for Inventory Report:", formId);
    // You can use formId for authorization or tracking
  }, [formId]);

  return (
    <Container>
      <AppBar position="static" style={{ backgroundColor: "#0B1F40" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{fontWeight:'bold'}}>
            Inventory Report
          </Typography>
        </Toolbar>
      </AppBar>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
          <Typography variant="h6">Stock Issue Report</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <StockIssue />
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
          <Typography variant="h6">Stock Return Report</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <StockReturnReport />
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3a-content" id="panel3a-header">
          <Typography variant="h6">Stock Summary Report</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <StockSummaryReport />
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Uncomment if needed */}
      {/* <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4a-content" id="panel4a-header">
          <Typography>Low Stock Report</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <StockSummaryReport />
          </Typography>
        </AccordionDetails>
      </Accordion> */}

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5a-content" id="panel5a-header">
          <Typography variant="h6">Stock Movement Report</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <StockMovementReport />
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel6a-content" id="panel6a-header">
          <Typography variant="h6">Vendor Purchase Report</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <VendorPurchaseReport />
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Container>
  );
}

export default InventoryReport;
